module.exports = __webpack_public_path__ + "static/media/psroll.7a683350.jpeg";